'use strict';

const changeLastNotification = (state, notification) => {
  state.lastNotification = notification;
};

export default {
  changeLastNotification
};
